// Section background-video controller — passive bg video, no UI controls.
// Pauses every `.sentiments-video-bg__media` element when scrolled out of
// view to save CPU/battery on long pages.

export function initSectionBgVideos() {
	const videos = document.querySelectorAll('.sentiments-video-bg__media');
	if (!videos.length) return;
	if (typeof IntersectionObserver !== 'function') return;

	const io = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				const v = entry.target;
				if (entry.isIntersecting) {
					if (v.paused) v.play().catch(() => {});
				} else if (!v.paused) {
					v.pause();
				}
			}
		},
		{ threshold: 0.01 }
	);

	videos.forEach((v) => io.observe(v));
}
